// Each template's form, by its catalog id (spec G14-templates): one module per template whose
// recipe the server runs. A template with none shows live's "not available yet" panel.
import type { ComponentType } from "react";

import { ActorSwapForm } from "./ActorSwapForm";
import { AdSwapForm } from "./AdSwapForm";
import { AnimateStaticAdForm } from "./AnimateStaticAdForm";
import { BackgroundSwapForm } from "./BackgroundSwapForm";
import { CartoonRealWorldForm } from "./CartoonRealWorldForm";
import { ChalkExplainerAdForm } from "./ChalkExplainerAdForm";
import { ClaymationAdForm } from "./ClaymationAdForm";
import { FlatCartoonForm } from "./FlatCartoonForm";
import { GreenScreenAdForm } from "./GreenScreenAdForm";
import { GrwmForm } from "./GrwmForm";
import { HeroShotForm } from "./HeroShotForm";
import { HooksForm } from "./HooksForm";
import { InstantResizeForm } from "./InstantResizeForm";
import { LanguageChangerForm } from "./LanguageChangerForm";
import { PersonalCloneForm } from "./PersonalCloneForm";
import { PixarSingingAdForm } from "./PixarSingingAdForm";
import { PixarTalkingAdForm } from "./PixarTalkingAdForm";
import { PixarWhiteboardAdForm } from "./PixarWhiteboardAdForm";
import { PodcastAdForm } from "./PodcastAdForm";
import { PromoteForm } from "./PromoteForm";
import { SceneVariationsForm } from "./SceneVariationsForm";
import { StaticAdForm } from "./StaticAdForm";
import { StreetInterviewAdForm } from "./StreetInterviewAdForm";
import { TalkingHeadOverlayForm } from "./TalkingHeadOverlayForm";
import { TranslateImageForm } from "./TranslateImageForm";
import type { TemplateFormProps } from "./kit";

export const FORMS: Readonly<Record<string, ComponentType<TemplateFormProps>>> = {
  "image-background-swap": BackgroundSwapForm,
  "chalk-explainer-ad": ChalkExplainerAdForm,
  "green-screen-yapper-ad": GreenScreenAdForm,
  "pixar-singing-ad": PixarSingingAdForm,
  "claymation-ad": ClaymationAdForm,
  "pixar-talking-ad": PixarTalkingAdForm,
  "pixar-whiteboard-ad": PixarWhiteboardAdForm,
  "podcast-ad": PodcastAdForm,
  "street-interview-ad": StreetInterviewAdForm,
  "static-ad-instant-resize": InstantResizeForm,
  "translate-static-image": TranslateImageForm,
  "product-scene-variations": SceneVariationsForm,
  "static-ad-generation": StaticAdForm,
  "animate-static-ad": AnimateStaticAdForm,
  hooks: HooksForm,
  "product-hero-shot": HeroShotForm,
  "main-character-actor-swap": ActorSwapForm,
  "language-changer": LanguageChangerForm,
  "promote-your-product": PromoteForm,
  "your-personal-clone": PersonalCloneForm,
  "talking-head-overlay": TalkingHeadOverlayForm,
  "ad-swap": AdSwapForm,
  "flat-cartoon": FlatCartoonForm,
  "cartoon-character-in-the-real-world": CartoonRealWorldForm,
  grwm: GrwmForm,
};
